/* unplugin-vue-components disabled */import script from "./centerList.vue?vue&type=script&setup=true&lang=js"
export * from "./centerList.vue?vue&type=script&setup=true&lang=js"

import "./centerList.vue?vue&type=style&index=0&id=53e8ebb2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e8ebb2"]])

export default __exports__